import { Progress as ProgressPrimitive } from '@base-ui/react/progress';

import { cn } from '@/lib/utils';

export type ProgressValueProps = ProgressPrimitive.Value.Props;

const ProgressValue = ({ className, ...props }: ProgressValueProps) => {
  return (
    <ProgressPrimitive.Value
      className={cn('ml-auto text-sm text-gray-600', className)}
      data-slot="progress-value"
      {...props}
    />
  );
};

export default ProgressValue;
